import {
  daysJsFormat,
  formatCurrency,
  isInstitutionGrouped,
  renderMonthByLetter,
  roles,
} from "../../../utils/constants";
import { onlyRoleMapping } from "../../../engine/AuthRoute";
import { Tag } from "antd";
import { colorPrimary } from "../../../root";
import dayjs from "../../../utils/dayjs";
import React from "react";
import { renderAdress } from "../../../shared/container/Addresses/AddresseItem/AddresseHelpers";

export const billsByTypeColumns = ({ type }) => {
  const columns = [
    {
      title: "Numéro interne",
      key: "bill_number",
      width: 80,
      dataIndex: "bill_number",
      sorter: true,
    },
    {
      title: "Mois",
      key: "prestationsRef.month",
      width: 100,
      dataIndex: "prestationsRef",
      render: prestationsRef => renderMonthByLetter(prestationsRef.month),
      sorter: (a, b) => {
        return a.prestationsRef.month - b.prestationsRef.month;
      },
    },
    {
      title: "Année",
      key: "prestationsRef.year",
      width: 80,
      dataIndex: "prestationsRef",
      render: prestationsRef => prestationsRef.year,
      sorter: (a, b) => {
        return a.prestationsRef.year - b.prestationsRef.year;
      },
    },
    {
      title: "Référence",
      key: "reference",
      width: 200,
      dataIndex: "reference",
      sorter: (a, b) => {
        return a.reference.localeCompare(b.reference);
      },
    },
    onlyRoleMapping([roles.admin, roles.permanance, roles.mandant])
      ? {
          title: "Institution",
          render: (n, record) => n.name,
          key: "institution",
          dataIndex: "institution",
          width: 200,
          sorter: (a, b) => {
            return a.institution.name.localeCompare(b.institution.name);
          },
        }
      : null,
    {
      title: "Prestation liée",
      width: 150,
      render: (prestations, record) => {
        if (type === "multiple") {
          return (
            <Tag
              color={colorPrimary}
            >{`Groupé: ${prestations.length} prestations`}</Tag>
          );
        } else {
          return prestations.map(s => <Tag color={"grey"}>{s.reference}</Tag>);
        }
      },
      key: "prestationsRef.references",
      dataIndex: "prestations",
      sorter: (a, b) => {
        return a.institution.name.localeCompare(b.institution.name);
      },
    },
    {
      title: "Date de création",
      width: 200,
      key: "createdAt",
      render: (date, u) => {
        return <span>{dayjs(date).format(daysJsFormat.full)}</span>;
      },
      dataIndex: "createdAt",
      sorter: (a, b) => {
        const dateA = new Date(a.createdAt);
        const dateB = new Date(b.createdAt);

        return dateA - dateB;
      },
    },
    {
      title: "Montant",
      width: 150,
      render: (montant, u) => {
        return <span>{formatCurrency(montant)}</span>;
      },
      dataIndex: "amount",
      key: "amount",
      sorter: (a, b) => {
        return a.amount - b.amount;
      },
    },
    {
      title: "Adresses",
      width: 300,
      render: (prestations, u) => {
        if (isInstitutionGrouped(u.institution, u)) {
          if (u.prestationsRef.billing === undefined) {
            return renderAdress(
              u.institution.defaultAddress,
              true,
              u.institution,
            );
          } else {
            return renderAdress(u.prestationsRef.billing, false, u.institution);
          }
        } else {
          return prestations.map(pres => renderAdress(pres.billing));
        }
      },
      dataIndex: "prestations",
    },
    onlyRoleMapping([roles.admin, roles.permanance])
      ? {
          title: "Date document",
          width: 200,
          key: "exportedDate",
          render: (date, u) => {
            return (
              <span>
                {date ? dayjs(date).format(daysJsFormat.day) : ""}
              </span>
            );
          },
          dataIndex: "exportedDate",
          sorter: (a, b) => {
            const dateA = new Date(a.exportedDate);
            const dateB = new Date(b.exportedDate);
            return dateA - dateB;
          },
        }
      : null,
    onlyRoleMapping([roles.admin, roles.permanance, roles.mandant])
      ? {
          title: "Emails facture actif",
          render: (institution, u) => {
            return institution.users.map(e => e.email + " ");
          },
          width: 200,
          dataIndex: "institution",
        }
      : null,
    {
      title: "Téléchargements",
      width: 200,
      render: (downloaded, u) => {
        return <span>{downloaded?.length || 0}</span>;
      },
      dataIndex: "downloaded",
    },
  ].filter(e => e !== null);

  return columns;
};
